<ng-container
  *ngLet="(selectedSubproject?.data?.hiddenSubtabs | filterByProperty : 'isActive' : true ) as hiddenSubtabs"
>
  <ng-container
    *ngIf="(screenSizeService.isHandset$ | async) === false; else hiddenSubtabs?.length ? handsetTemplate : noHiddenSubtabs"
  >
    <div class="pageSubHeader">
      <app-section-title svgIcon="eye-off" [title]="hiddenTitle" headerSize="h4"></app-section-title>
    </div>

    <ng-container *ngIf="hiddenSubtabs?.length; else noHiddenSubtabs">
      <div class="border-top"></div>
      <app-horizontal-navigation>
        <div class="customHorizontalNavContainer">
          <button
            *ngFor="let tab of hiddenSubtabs; trackBy: trackHiddenSubtabs"
            mat-flat-button
            class="mr-2 horizontalNavButton text-transform-initial"
            [routerLink]="[tab.id]"
            routerLinkActive="mat-secondary"
            (click)="onSubtabChanged(tab.id)"
            [attr.data-testId]="tab.name"
          >
            {{tab.name}}
          </button>
        </div>
      </app-horizontal-navigation>
    </ng-container>
  </ng-container>

  <ng-template #noHiddenSubtabs>
    <div class="px-spacer-responsive py-3 border-top">
      <i i18n="@@dprDetails.dprHiddenPage.txtNoActiveTabs">
        You have no active subtabs. Go to Project Setup -> Hidden Free Text Fields in order to add or activate any.
      </i>
    </div>
  </ng-template>

  <ng-template #handsetTemplate>
    <app-navigation-select
      [items]="hiddenSubtabs | mapNavigationMenuItem : 'id' : 'name' : 'id'"
      [initialSelection]="preselectedItem"
      (selectedItemChanges)="onSelectionChange($event)"
    ></app-navigation-select>
  </ng-template>

  <router-outlet *ngIf="hiddenSubtabs.length" (activate)="onComponentActivated($event)"></router-outlet>
</ng-container>
